<template lang="pug">
  div
    form(@submit.prevent="fetchResume")
      .columns.align-center
        .column.col-4.col-sm-12.mb-2.pb-2
          form-group(label="Início")
            datepicker(v-model="q.initialDate")
        .column.col-4.col-sm-12.mb-2.pb-2
          form-group(label="Fim")
            datepicker(v-model="q.finalDate" fullDay)
        .column.col-auto
          button.btn.s-circle.btn-primary
            i.fas.fa-filter
    .divider
    .flex-centered(v-if="loading") #[.loading.loading-lg]
    div(v-else-if="!error && resume")
      .columns
        .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2.pb-2
          box(title="Ganhos" :value="resume.gains | currency('R$ ')" icon="fas fa-money-bill-alt" box-style="success")
        .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2.pb-2
          box(title="Assinaturas" :value="resume.filiationSubscriptions" icon="fas fa-check-square" box-style="primary")
        .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2.pb-2
          box(title="Compras" :value="resume.filiationPurchases" icon="fas fa-shopping-cart" box-style="danger")
        .column.col-3.col-lg-4.col-md-6.col-xs-12.mb-2.pb-2
          box(title="Acessos" :value="resume.filiationAccess" icon="fas fa-mouse-pointer" box-style="warning")
      .columns
        .column.col-6.col-sm-12.mb-2.pb-2
          filiation-purchases-card(:filiation="filiation" :q="this.q")
        .column.col-6.col-sm-12.mb-2.pb-2
          filiation-subscriptions-card(:filiation="filiation" :q="this.q")
</template>

<script>
import filiations from '@/services/filiations'
import FiliationPurchasesCard from './FiliationPurchasesCard'
import FiliationSubscriptionsCard from './FiliationSubscriptionsCard'

export default {
  data() {
    return {
      loading: false,
      error: null,
      resume: null,
      q: { initialDate: null, finalDate: null },
    }
  },
  components: { FiliationPurchasesCard, FiliationSubscriptionsCard },
  props: { filiation: { type: Object, required: true } },
  methods: {
    async fetchResume() {
      try {
        this.loading = true
        const { data } = await filiations.resume(this.filiation.id, {
          q: this.q,
        })
        this.resume = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchResume()
  },
}
</script>
